import { render, staticRenderFns } from "./IconGuarantee.vue?vue&type=template&id=e2a75ee2"
import script from "./IconGuarantee.vue?vue&type=script&lang=js"
export * from "./IconGuarantee.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports